<template>
  <div class="profile-page">
    <section class="section-profile-cover section-shaped my-0">
      <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </section>
    <section class="section section-skew">
      <div class="container">
        <card class="card-profile mt--300" no-body shadow>
          <div class="px-4">
            <div class="text-center mt-5">

              <h3>درباره ما</h3>


              <div class="mt-4" style="text-align: justify">یکی از مهم‌ترین ابزارهای ارتباطی قرن ۲۱ شبکه جهانی اینترنت
                بوده و هست. اما حتی با پیشرفت‌های چشمگیر بشر در شبکه، همچنان حفظ امنیت و حریم خصوصی در این فضای مجازی با
                چالش‌های زیادی مواجه است.
                از ابزارهای موجود در SafeNote می‌توانید برای ذخیره امن یادداشت‌ها، ارسال امن پیام خصوصی از طریق لینک یا ارسال و دریافت پیام‌های ناشناس و
                ... استفاده کنید.
              </div>
              <div style="text-align: justify">برای تضمین محرمانگی و امنیت نگهداری داده‌ها از الگوریتم‌های رمزنگاری
                End-to-End و
                برای انتقال داده‌ها از پروتکل رمزنگاری SSL استفاده شده است.
              </div>

              <img class="mt-4" src="/img/brand/safenote-blue.png" alt="logo">

              <div class="text-primary h5 font-weight-500 mt-2">
                ما برای حفظ حریم خصوصی کاربران می‌جنگیم.
              </div>
              <div/>
              <br>

            </div>
          </div>
        </card>
      </div>
    </section>
  </div>
</template>

<script>
import Inputs from "./components/Inputs";
import BaseDropdown from "../components/BaseDropdown";

export default {
  components: {
    Inputs,
    BaseDropdown
  },
  data() {
    return {
      showMore: false
    }
  }
};
</script>

<style scoped>
.dropdown {
  display: block;
}

.dropdown .btn {
  width: 100%;
  display: block;
}

</style>
